import React, { useEffect, useState } from "react";
import "./ProgressBarSection.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import "react-step-progress-bar/styles.css";
import { NameSection } from "../NameSection";
import { NumberSection } from "../NumberSection";
import { SellSelectSection } from "../SellSelectSection";
import { MarketingSection } from "../MarketingSection";
import { MarketingBudget } from "../MarketingBudget";
import { RevenuSection } from "../RevenuSection";
import { Header } from "../Header";
import { db } from "../../firebase/firebase";
import { ThankSection } from "../ThankSection/ThankSection";
import {   serverTimestamp } from "firebase/firestore";
export const ProgressBarSection = () => {
  const [counter, setCounter] = useState(0);
  const [percentage, setPercentage] = useState(0);
  const [userName, setUserName] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [RadioOptios, setRadioOptios] = useState("");
  const [checkboxOptios, setCheckboxOptios] = useState([]);
  const [BudgetOptios, setBudgetOptios] = useState("");
  const [revenuText, setRevenuText] = useState("");
  const [ThankShow, setThankShow] = useState(false);
  const [countyCode, setCountyCode] = useState("+971");

  useEffect(() => {
    localStorage.removeItem("userInfo");
  }, []);

  const sendData = (data) => {
    setCounter(data + 1);
    setPercentage(percentage + 20);
  };
  const sendBackData = () => {
    setCounter(counter - 1);
    setPercentage(percentage - 20);
  };
  const submitData = () => {
    const userInfo = {
      userName: userName,
      userNumber: countyCode + " " + userNumber,
      userSelectSales: RadioOptios,
      userUsingCurrentMarketing: checkboxOptios,
      userMontlyIncome: BudgetOptios,
      userProblemFacingText: revenuText,
      createdAT: serverTimestamp()
    };
    db.collection("userInfo").add(userInfo);
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    setThankShow(true);
    setTimeout(() => {
      window.location.reload();
    }, 3500);
  };

  return (
    <>
      <Header sendBackData={sendBackData} count={counter} />
      <div className="container mt-5 text-center">
        <div className="w-75 mx-auto">
          <ProgressBar
            percent={percentage}
            filledBackground="linear-gradient(to right, #cff128, #cff128)"
            className="w-25"
          >
            {Array(6)
              .fill(0)
              .map((items, i) => (
                <Step
                  key={i}
                  transition="scale"
                  children={({ accomplished }) => (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        width: 20,
                        height: 20,
                        color: "black",
                        backgroundColor: accomplished ? "#cff128" : "#d3d3d3",
                      }}
                    >
                      <p className="progrebar_steps"></p>
                    </div>
                  )}
                />
              ))}
          </ProgressBar>
        </div>
        {counter === 0 && (
          <NameSection
            sendData={sendData}
            userSetname={setUserName}
            userName={userName}
          />
        )}
        {counter === 1 && (
          <NumberSection
            sendData={sendData}
            userSetNumber={setUserNumber}
            userNumber={userNumber}
            userName={userName}
            setCountryCode={setCountyCode}
            countyCode={countyCode}
          />
        )}
        {counter === 2 && (
          <SellSelectSection
            sendData={sendData}
            setSellSelect={setRadioOptios}
            SellSelect={RadioOptios}
          />
        )}
        {counter === 3 && (
          <MarketingSection
            sendData={sendData}
            setCheckboxSelect={setCheckboxOptios}
            CheckboxSelect={checkboxOptios}
          />
        )}
        {counter === 4 && (
          <MarketingBudget
            sendData={sendData}
            setBudgetSelect={setBudgetOptios}
            budgetOptios={BudgetOptios}
          />
        )}
        {counter === 5 && (
          <RevenuSection
            sendData={sendData}
            setRevenu={setRevenuText}
            revenuText={revenuText}
            submitData={submitData}
            ThankShow ={ThankShow}
          />
        )}
        <ThankSection userName={userName} ThankShow ={ThankShow}/>
      </div>
    </>
  );
};
